module.exports = __webpack_public_path__ + "static/drying-mobile-5e7db3952e291df9fa787eeea3845b10.svg";